import Axios from 'axios';
import { USER_PROFILE } from '_constants';
import { toggleReadLoader, toggleWriteLoader } from 'actions';
import AuthService from '../utils/authentication/auth.service';
import { isResponseSuccess } from 'helpers';
import { LOGIN, APPOINTMENTS } from '../constants';
import { fetchCalendars } from './appointments.services';
import _ from 'lodash';
import { fetchOffice } from './member.services';
import { getNotificationCount } from '../actions/notifications.actions';
import moment from 'moment';
const authService = new AuthService();
const CancelToken = Axios.CancelToken;
let tokenCancel;
/* eslint-disable no-undef */
/* eslint-disable require-atomic-updates */

let envResponse = Axios.get('/env_config/config.json');

export const request = (url, method, requestBody = {}, customHeaders = {}, isUrlAbsolute = false) => async (dispatch, getState) => {
  if (!url || !method) {
    return Promise.reject(new Error('url/method missing'));
  }

  if (!isResponseSuccess(envResponse)) {
    envResponse = await Axios.get('/env_config/config.json');
    if (!isResponseSuccess(envResponse)) { return Promise.reject(new Error('Error fetching configurations')); }
  }

  const isLoginPath = window.location.pathname === '/' || window.location.pathname === '/login' || window.location.pathname === '/sso' || window.location.pathname === '/azureb2c';

  const headers = {
    'X-RED-APIKey': _.get(envResponse, 'data.contactsApiKey', ''),
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  if (authService.isAuthenticated()) {
    headers['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
  }

  if (method === 'GET') {
    dispatch(toggleReadLoader(true));
  } else {
    dispatch(toggleWriteLoader(true));
  }

  try {
    const response = await Axios.request({
      baseURL: !isUrlAbsolute ? _.get(envResponse, 'data.contactsApiUrl', '') : '',
      url: url,
      method: method,
      headers: { ...headers, ...customHeaders },
      data: requestBody
    });

    if (method === 'GET') {
      dispatch(toggleReadLoader(false));
    } else {
      dispatch(toggleWriteLoader(false));
    }

    if (!isLoginPath && (method === 'PUT' || method === 'PATCH' || method === 'POST') && isResponseSuccess(response)) {
      dispatch(getNotificationCount());
    }

    return response;
  } catch (err) {
    if (method === 'GET') {
      dispatch(toggleReadLoader(false));
    } else {
      dispatch(toggleWriteLoader(false));
    }
    return Promise.reject(err);
  }
};

export const setHeader = async () => {
  if (!isResponseSuccess(envResponse)) {
    envResponse = await Axios.get('/env_config/config.json');
    if (!isResponseSuccess(envResponse)) { return Promise.reject(new Error('Error fetching configurations')); }
  }

  const headers = {
    'X-RED-APIKey': _.get(envResponse, 'data.contactsApiKey', ''),
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  if (authService.isAuthenticated()) {
    headers['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
  }
  return headers;
};

// TODO cosolidate getCancelTokenRequest to reduce repeated code below
export const getCancelTokenRequest = (url, currentToken, isUrlAbsolute = false) => async dispatch => {
  if (!url) {
    return Promise.reject(new Error('url/method missing'));
  }

  if (!isResponseSuccess(envResponse)) {
    envResponse = await Axios.get('/env_config/config.json');
    if (!isResponseSuccess(envResponse)) { return Promise.reject(new Error('Error fetching configurations')); }
  }

  const headers = {
    'X-RED-APIKey': _.get(envResponse, 'data.contactsApiKey', ''),
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  if (authService.isAuthenticated()) {
    headers['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
  }

  dispatch(toggleReadLoader(true));
  tokenCancel && tokenCancel(url);
  const currentToken =
       new CancelToken(function executor (c) {
         tokenCancel = c;
       });

  try {
    const response = await Axios.request({
      baseURL: !isUrlAbsolute ? _.get(envResponse, 'data.contactsApiUrl', '') : '',
      url: url,
      method: 'GET',
      headers: { ...headers },
      cancelToken: currentToken
    });

    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

const get = (url, requestBody, sourceToken) => {
  return request(url, 'GET', requestBody, sourceToken);
};

const post = (url, requestBody) => {
  return request(url, 'POST', requestBody);
};

const put = (url, requestBody) => {
  return request(url, 'PUT', requestBody);
};

const patch = (url, requestBody) => {
  return request(url, 'PATCH', requestBody);
};

const _delete = (url) => {
  return request(url, 'DELETE');
};

const login = (username, password, refreshToken) => async (dispatch, getState) => {
  const loginPayload = {
  };

  if (refreshToken) {
    loginPayload.refreshToken = refreshToken;
  } else {
    loginPayload.username = username;
    loginPayload.password = password;
  }
  return dispatch(loginInternal(loginPayload));
};

const azureB2CLogin = (token) => async (dispatch, getState) => {
  const loginPayload = {
    azureB2CToken: token
  };
  return dispatch(loginInternal(loginPayload));
};

const loginInternal = (loginPayload) => async (dispatch, getState) => {
  const { login = {} } = getState();
  const envdata = await Axios.get('/env_config/config.json');

  if (login.deviceId) {
    loginPayload.clientDeviceInfo = {
      deviceId: login.deviceId || null,
      deviceType: login.deviceType,
      appVersion: `${login.appVersion}+${_.get(envdata, 'data.version', '')}`
    };
  }

  try {
    const loginResponse = await dispatch(post('/login', loginPayload));
    dispatch({ type: LOGIN.START_LOGIN });
    if (isResponseSuccess(loginResponse)) {
      const { accessToken = '', memberResource = '', expiryDate = '', refreshToken = '' } = loginResponse.data;
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('memberResource', memberResource);
      localStorage.setItem('accessTokenExpiryDate', expiryDate);
      localStorage.setItem('refreshToken', refreshToken);
      const memberResponse = await dispatch(request(memberResource, 'GET', {}, {}, true));
      const calendarResponse = await dispatch(fetchCalendars());
      if (isResponseSuccess(memberResponse)) {
        let memberInfo = { ...memberResponse.data };
        const { officeKey = '' } = memberInfo;
        const officeResponse = await dispatch(fetchOffice(officeKey));
        if (isResponseSuccess(officeResponse)) {
          memberInfo = { ...memberInfo, ...officeResponse.data };
        }
        localStorage.setItem('member', JSON.stringify(memberInfo));
        dispatch({ type: USER_PROFILE.UPDATE_MEMBER, value: memberInfo });
      }
      if (isResponseSuccess(calendarResponse)) {
        const calendar = _.isArray(calendarResponse.data) && calendarResponse.data.length > 0 && calendarResponse.data[0];
        dispatch({ type: APPOINTMENTS.UPDATE_CALENDAR, calendar: calendar });
        localStorage.setItem('agentCalendar', JSON.stringify(calendar));
      }
    }
    return loginResponse;
  } catch (err) {
    dispatch({ type: LOGIN.LOGIN_ERROR, payload: err });
    console.error(err);
    return Promise.reject(err);
  } finally {
    dispatch({ type: LOGIN.END_LOGIN });
  }
};

const ssoLogin = (ssoToken) => async (dispatch, getState) => {
  const { login = {} } = getState();
  const loginPayload = {
    ssoToken: ssoToken
  };
  const envdata = await Axios.get('/env_config/config.json');

  if (login.deviceId) {
    loginPayload.clientDeviceInfo = {
      deviceId: login.deviceId || null,
      deviceType: login.deviceType,
      appVersion: `${login.appVersion}+${_.get(envdata, 'data.version', '')}`
    };
  }
  const loginResponse = await dispatch(post('/login', loginPayload));

  if (isResponseSuccess(loginResponse)) {
    const { accessToken = '', memberResource = '', expiryDate = '', refreshToken = '' } = loginResponse.data;
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('memberResource', memberResource);
    localStorage.setItem('accessTokenExpiryDate', expiryDate);
    localStorage.setItem('refreshToken', refreshToken);
    const memberResponse = await dispatch(request(memberResource, 'GET', {}, {}, true));
    const calendarResponse = await dispatch(fetchCalendars());
    if (isResponseSuccess(calendarResponse)) {
      const calendar = _.isArray(calendarResponse.data) && calendarResponse.data.length > 0 && calendarResponse.data[0];
      dispatch({ type: APPOINTMENTS.UPDATE_CALENDAR, calendar: calendar });
      localStorage.setItem('agentCalendar', JSON.stringify(calendar));
    }
    if (isResponseSuccess(memberResponse)) {
      localStorage.setItem('member', JSON.stringify(memberResponse.data));
      dispatch({ type: USER_PROFILE.UPDATE_MEMBER, value: memberResponse.data });
    }
  }

  return loginResponse;
};

const loadSession = () => (dispatch, getState) => {
  const { login = {} } = getState();
  if (localStorage['member']) {
    var member = localStorage['member'];
    dispatch({ type: USER_PROFILE.UPDATE_MEMBER, value: JSON.parse(member) });
  }
  if (localStorage['isTermsAccepted']) {
    if (!_.isEqual(localStorage['isTermsAccepted'], login.isTermsAccepted.toString())) {
      dispatch({ type: LOGIN.ACCEPT_LOGIN_TERMS });
    }
  }
  if (localStorage['agentCalendar']) {
    dispatch({ type: APPOINTMENTS.UPDATE_CALENDAR, calendar: JSON.parse(localStorage['agentCalendar']) });
  }
};

export const getContacts = () => async dispatch => {
  tokenCancel && tokenCancel(`at ${moment()}`);
  const envData = await envResponse;
  try {
    dispatch(toggleReadLoader(true));
    const response = Axios.request({
      baseURL: await _.get(envData, 'data.contactsApiUrl', ''),
      url: '/contacts',
      method: 'GET',
      headers: await ContactsApiProvider.setHeader(),
      cancelToken: new CancelToken(function executor (c) { tokenCancel = c; })
    });
    dispatch(toggleReadLoader(false));
    return response;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const ContactsApiProvider = {
  getCancelTokenRequest,
  get,
  post,
  put,
  patch,
  delete: _delete,
  login,
  azureB2CLogin,
  loadSession,
  ssoLogin,
  getContacts,
  setHeader
};
